import React from "react";
import { getDefaultLocale } from "./config";
import LocaleService from "./LocaleService";
var defaultLocaleContext = {
    availableLocales: [],
    get locale() {
      return LocaleService.JUTRO_PRIVATE_NOT_USE_LOCALE_SERVICE ? getDefaultLocale() : LocaleService.getCurrentLocale() || getDefaultLocale();
    },
    dateLocale: {}
  },
  LocaleContext = React.createContext(defaultLocaleContext);
export var LocaleContextProvider = LocaleContext.Provider;
export var LocaleContextConsumer = LocaleContext.Consumer;
export default LocaleContext;